import React from "react";
import PartOneFirstPart from "./partOneParts/partOne";
import PartOneSecondPart from "./partOneParts/partTwo";
import PartOneThirdPart from "./partOneParts/partThree";
import { NidInquiryStatusType } from "../../../enums/index";
const PartOne = (props) => {
  return props.customer.NidInquiryStatus === NidInquiryStatusType.Accepted() ||
    props.customer.NidInquiryStatus === NidInquiryStatusType.Rejected() ? (
    <PartOneFirstPart customer={props.customer}></PartOneFirstPart>
  ) : props.customer.NidInquiryStatus === NidInquiryStatusType.InProgress() ? (
    <PartOneSecondPart
      customer={props.customer}
      setCustomer={props.setCustomer}
      lastInquiry={props.lastInquiry}
      setRejectBtn={props.setRejectBtn}
      rejectBtn={props.rejectBtn}
      acceptBtn={props.acceptBtn}
      setAcceptBtn={props.setAcceptBtn}
      verifyBtn={props.verifyBtn}
      setVerifyBtn={props.setVerifyBtn}
    ></PartOneSecondPart>
  ) : props.customer.NidInquiryStatus ===
    NidInquiryStatusType.ReadyForInquiry() ? (
    <PartOneThirdPart
      customer={props.customer}
      setCustomer={props.setCustomer}
    ></PartOneThirdPart>
  ) : (
    <></>
  );
};
export default PartOne;
